import { Chip, ChipsWrapper } from './styles'

export interface ChipItem<T extends string> {
  value: T
  label: string
}

interface FilterChipsProps<T extends string> {
  items: ChipItem<T>[]
  value: T
  onChange: (value: T) => void
}

/**
 * 단일 선택 필터 칩 그룹.
 *
 * Tabs와 시각적으로 다름 (rounded pill, 검은 active) — 같은 `<button aria-pressed>` 패턴이지만
 * 디자인 시스템상 필터/카테고리 선택과 탭 네비게이션을 구분하기 위해 별도 컴포넌트.
 */
export default function FilterChips<T extends string>({ items, value, onChange }: FilterChipsProps<T>) {
  return (
    <ChipsWrapper>
      {items.map((item) => (
        <Chip
          key={item.value}
          type='button'
          aria-pressed={value === item.value}
          onClick={() => onChange(item.value)}
        >
          {item.label}
        </Chip>
      ))}
    </ChipsWrapper>
  )
}
